//制造业重大项目方向

const indexAdmin = () => import('./indexAdmin');
const indexAppl = () => import(/* webpackChunkName: "herb" */ './indexAppl');
const edit = () => import('./edit.vue');
const recommend=()=>import('./recommend.vue');

export default {
  routes: [
    {
      path: '/china/v2024/indexAppl',
      name: 'china_v2024_index_appl',
      component: indexAppl,
      meta:{public:true}
    },
    {
      path: '/china/v2024/indexAdmin',
      name: 'china_v2024_index_admin',
      component: indexAdmin,
      meta: {public: true}
    },
    {
      path: '/china/v2024/edit',
      name: 'china_v2024_edit',
      component: edit,
      meta: {public: true}
    },
    {
      path: '/china/v2024/recommend',
      name: 'china_v2024_recommend',
      component: recommend,
      meta: {public: true}
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/special/china2025/V2024/router.js